"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWSDateFormatToken = void 0;
// ex: 2021-05-20
exports.AWSDateFormatToken = 'yyyy-LL-dd';
